import { memo, useEffect } from 'react';
import { AuthorCard } from '@features/common/AuthorCard/index.tsx';
import type { Article } from '@shared/types/articles';
import DescriptionViewer from '@shared/ui/viewer-note-editor-content/description-viewer/index.tsx';
import * as st from './styles.module.scss';

export const ArticleCardLarge = memo((props: Article) => {
  const { title, content, author } = props;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props]);
  return (
    <>
      <h1 className={st.title}>{title}</h1>
      <AuthorCard author={author} className={st.author} />
      <DescriptionViewer isAlwaysFull className={st.description} description={content} />
    </>
  );
});
